module.exports = __webpack_public_path__ + "staticcomp/img/content_1.2cfc020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/content_1.jpg
// module id = Yrli
// module chunks = 39